/* eslint-disable consistent-return */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-return-assign */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/button-has-type */
import React, { useEffect, useState, useRef } from "react";
import moment from "moment";
import { createPortal } from "react-dom";
import { MoreVertical, CheckCircle, AlertTriangle, X, XCircle, ArrowRight } from 'lucide-react';
import Page from "../../../components/Page";
import adminServices from "../../../services/adminServices";

const statusStyles = {
    Live: "bg-green-100 text-green-700",
    Inactive: "bg-yellow-100 text-yellow-700",
    Archived: "bg-gray-100 text-gray-500"
};

const typeStyles = {
    ASSESSMENT: "bg-orange-100 text-orange-700",
    COURSE: "bg-blue-100 text-blue-700",
    EBOOK: "bg-purple-100 text-purple-700"
};






export default function ContentBankUI() {
    const menuRefs = useRef({});
    const tableContainerRef = useRef(null);
    const [data, setData] = useState([]);

    const [menuPosition, setMenuPosition] = useState({ top: 0, right: 0 });
    const [page, setPage] = useState(1);

    const [typeFilter, setTypeFilter] = useState("all");
    const [audience, setAudience] = useState("All");
    const [search, setSearch] = useState("");
    const [size] = useState(10);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(false);
    const [activeTab, setActiveTab] = useState("all");
    const [count, setCount] = useState({});
    const [subtype, setSubType] = useState("");
    const [openActionMenuId, setOpenActionMenuId] = useState(null);
    const [makeLiveStep, setMakeLiveStep] = useState(null);
    const [archiveModal, setArchiveModal] = useState(false);
    const [makeInactiveModal, setMakeInactiveModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [reclassifyStep, setReclassifyStep] = useState(null);
    const [assessmentTypeList, setAssessmentTypeList] = useState([]);

    const tabs = [
        { label: "All", data: "all", count: count?.all, disable: false },
        { label: "Inactive", data: "INACTIVE", count: count?.inactive, disable: false },
        { label: "Live", data: "ACTIVE", count: count?.active, disable: false },
        { label: "Archived", data: "ARCHIVED", count: count?.archived, disable: true }
    ];

    useEffect(() => {
        const container = tableContainerRef.current;
        if (!container) return;

        const handleScroll = () => {
            if (openActionMenuId !== null) {
                setOpenActionMenuId(null);
            }
        };

        container.addEventListener("scroll", handleScroll);
        return () => container.removeEventListener("scroll", handleScroll);
    }, [openActionMenuId]);

    useEffect(() => {
        const handleWindowScroll = () => {
            if (openActionMenuId !== null) {
                setOpenActionMenuId(null);
            }
        };

        window.addEventListener("scroll", handleWindowScroll, true);
        return () => window.removeEventListener("scroll", handleWindowScroll, true);
    }, [openActionMenuId]);

    const useLockBodyScroll = (lock) => {
        useEffect(() => {
            if (lock) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.overflow = '';
            }

            return () => {
                document.body.style.overflow = '';
            };
        }, [lock]);
    };

    useEffect(() => {
        getAssessmentTypeList();
    }, []);

    const getAssessmentTypeList = async () => {
        try {
            const result = await adminServices.getAssessmentTypeDropdown();

            if (result && result.ok) {
                const list = result.data?.data || result.data || [];
                setAssessmentTypeList(list.filter(item => item.is_active));
            }
        } catch (error) {
            console.error("Assessment Type dropdown API not ready:", error);
            setAssessmentTypeList([]);
        }
    };

    function MakeLiveConfirmModal({ row, onClose, onContinue }) {
        useLockBodyScroll(true);
        return (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40" style={{ paddingTop: '64px' }}>
                <div className="bg-white rounded-2xl shadow-xl w-full max-w-md mx-4 p-6 relative max-h-[85vh] overflow-y-auto">
                    <button
                        onClick={onClose}
                        className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
                    >
                        <X className="w-5 h-5" />
                    </button>

                    <h2 className="text-lg font-semibold text-gray-900 mb-4">Make Content Live</h2>

                    <div className="flex items-center gap-3 bg-amber-50 border border-amber-200 rounded-lg px-4 py-3 mb-4">
                        <AlertTriangle className="w-5 h-5 text-amber-500 flex-shrink-0" />
                        <span className="text-sm font-semibold text-amber-700">{row.title}</span>
                    </div>

                    <p className="text-sm text-gray-600 mb-6">
                        You are about to publish this content. It will be visible to learners based on plan membership. Continue to set the audience.
                    </p>

                    <div className="flex gap-3 justify-end">
                        <button
                            onClick={onClose}
                            className="px-5 py-2 rounded-lg border border-gray-200 text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={onContinue}
                            className="px-5 py-2 rounded-lg bg-blue-600 text-white text-sm font-medium hover:bg-blue-700 transition-colors"
                        >
                            Continue
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    function MakeInactiveModal({ row, onClose, onConfirm }) {
        useLockBodyScroll(true);

        const [loading, setLoading] = useState(false);

        const handleConfirm = async () => {
            setLoading(true);
            await onConfirm();
            setLoading(false);
        };

        return (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40" style={{ paddingTop: '64px' }}>
                <div className="bg-white rounded-2xl shadow-xl w-full max-w-md mx-4 p-6 relative max-h-[85vh] overflow-y-auto">
                    <button
                        onClick={onClose}
                        className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
                    >
                        <X className="w-5 h-5" />
                    </button>

                    <h2 className="text-lg font-semibold text-gray-900 mb-4">Make Content Inactive</h2>

                    <div className="flex items-center gap-3 bg-amber-50 border border-amber-200 rounded-lg px-4 py-3 mb-4">
                        <AlertTriangle className="w-5 h-5 text-amber-500 flex-shrink-0" />
                        <span className="text-sm font-semibold text-amber-700">{row.title}</span>
                    </div>

                    <p className="text-sm text-gray-600 mb-6">
                        This content will be moved back to the review queue. It will no longer be visible to learners. This action can be undone.
                    </p>

                    <div className="flex gap-3 justify-end">
                        <button onClick={onClose} className="px-5 py-2 rounded-lg border border-gray-200 text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors">
                            Cancel
                        </button>
                        <button
                            onClick={() => handleConfirm(row)}
                            disabled={loading}
                            className="px-5 py-2 rounded-lg bg-blue-600 text-white text-sm font-medium hover:bg-blue-700 disabled:opacity-50 transition-colors"
                        >
                            {loading ? "Processing..." : "Make Inactive"}
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    function ReclassifyConfirmModal({ row, onClose, onContinue }) {
        useLockBodyScroll(true);
        return (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40" style={{ paddingTop: '64px' }}>
                <div className="bg-white rounded-2xl shadow-xl w-full max-w-md mx-4 p-6 relative max-h-[85vh] overflow-y-auto">
                    <button
                        onClick={onClose}
                        className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
                    >
                        <X className="w-5 h-5" />
                    </button>

                    <h2 className="text-lg font-semibold text-gray-900 mb-4">Reclassify Audience</h2>

                    <div className="flex items-center gap-3 bg-red-50 border border-red-200 rounded-lg px-4 py-3 mb-4">
                        <AlertTriangle className="w-5 h-5 text-red-500 flex-shrink-0" />
                        <span className="text-sm font-semibold text-red-700">{row.title}</span>
                    </div>

                    <p className="text-sm text-gray-600 mb-6">
                        This is a destructive action. Reclassifying will remove this content from incompatible plans which will affect learners in that plan. Continue?
                    </p>

                    <div className="flex gap-3 justify-end">
                        <button onClick={onClose} className="px-5 py-2 rounded-lg border border-gray-200 text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors">
                            Cancel
                        </button>
                        <button onClick={onContinue} className="px-5 py-2 rounded-lg bg-red-600 text-white text-sm font-medium hover:bg-red-700 transition-colors">
                            Continue
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    function MakeLiveAudienceModal({ row, onClose, onSubmit }) {

        useLockBodyScroll(true);
        const [selected, setSelected] = useState(null);
        const [loading, setLoading] = useState(false);

        const audiences = [
            {
                value: "B2C",
                label: "B2C Only",
                desc: "Visible to B2C learners via Plans & Pricing. Not accessible to B2B tenants."
            },
            {
                value: "B2B",
                label: "B2B Only",
                desc: "Accessible to B2B tenants via plan assignment. Not visible to B2C learners."
            },
            {
                value: "BOTH",
                label: "Both",
                desc: "Accessible to all learners (B2C and B2B)."
            }
        ];

        const handleSubmit = async () => {
            if (!selected) return;
            setLoading(true);
            await onSubmit(selected);
            setLoading(false);
        };

        return (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40" style={{ paddingTop: '64px' }}>
                {/* <div className="fixed inset-0 z-50 flex justify-center pt-6 bg-black/40"> */}
                <div className="bg-white rounded-2xl shadow-xl w-full max-w-lg mx-4 p-10 relative max-h-[85vh] overflow-y-auto">
                    <button onClick={onClose} className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors">
                        <X className="w-5 h-5" />
                    </button>
                    <h2 className="text-lg font-semibold text-gray-900 mb-5">Make Live</h2>
                    <div className="bg-gray-50 border border-gray-200 rounded-xl p-4 mb-5">
                        <p className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-3">Content Details</p>
                        <div className="grid grid-cols-2 gap-y-3">
                            <div>
                                <p className="text-xs text-gray-400 mb-0.5">Title</p>
                                <p className="text-sm font-semibold text-gray-800">{row.title}</p>
                            </div>
                            <div>
                                <p className="text-xs text-gray-400 mb-0.5">Type</p>
                                <p className="text-sm font-semibold text-gray-800">
                                    {row.type === "ASSESSMENT" ? "Assessment" : row.type === "EBOOK" ? "Ebook" : "Course"}
                                </p>
                            </div>

                            {row?.type === "COURSE" ?
                                <div>
                                    <p className="text-xs text-gray-400 mb-0.5">Course Type</p>
                                    <p className="text-sm font-semibold text-gray-800">
                                        {row.assessment_type_code ? `${row.assessment_type_code?.toUpperCase()}` : "—"}
                                    </p>
                                </div>
                                :
                                <div>
                                    <p className="text-xs text-gray-400 mb-0.5">Category · Test Type</p>
                                    <p className="text-sm font-semibold text-gray-800">
                                        {row.assessment_type_code ? `${row.assessment_type_code?.toUpperCase()} · ${row.sub_type}` : "—"}
                                    </p>
                                </div>}
                            <div>
                                <p className="text-xs text-gray-400 mb-0.5">Status</p>
                                <p className="text-sm font-semibold text-gray-800">
                                    INACTIVE <span className="text-gray-400">→</span> <span className="text-green-600">LIVE</span>
                                </p>
                            </div>
                        </div>
                    </div>

                    <p className="text-sm font-medium text-gray-700 mb-3">
                        Select audience <span className="text-red-500">*</span>
                    </p>
                    <div className="flex flex-col gap-2 mb-6">
                        {audiences.map((opt) => (
                            <label
                                key={opt.value}
                                onClick={() => setSelected(opt.value)}
                                className={`flex items-start gap-3 border rounded-xl px-4 py-3 cursor-pointer transition-all ${selected === opt.value
                                    ? "border-blue-500 bg-blue-50"
                                    : "border-gray-200 hover:border-gray-300 hover:bg-gray-50"
                                    }`}
                            >
                                <div className={`mt-0.5 w-4 h-4 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-colors ${selected === opt.value ? "border-blue-600" : "border-gray-300"
                                    }`}>
                                    {selected === opt.value && (
                                        <div className="w-2 h-2 rounded-full bg-blue-600" />
                                    )}
                                </div>
                                <div>
                                    <p className="text-sm font-semibold text-gray-800">{opt.label}</p>
                                    <p className="text-xs text-gray-500 mt-0.5">{opt.desc}</p>
                                </div>
                            </label>
                        ))}
                    </div>

                    <div className="flex gap-3 justify-end">
                        <button
                            onClick={onClose}
                            className="px-5 py-2 rounded-lg border border-gray-200 text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={handleSubmit}
                            disabled={!selected || loading}
                            className="px-5 py-2 rounded-lg bg-blue-600 text-white text-sm font-medium hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                        >
                            {loading ? "Publishing..." : "Make Live"}
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    function ArchiveConfirmModal({ row, onClose, onConfirm }) {
        useLockBodyScroll(true);
        const [loading, setLoading] = useState(false);

        const handleConfirm = async () => {
            setLoading(true);
            await onConfirm();
            setLoading(false);
        };


        return (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40" style={{ paddingTop: '64px' }}>
                <div className="bg-white rounded-2xl shadow-xl w-full max-w-md mx-4 p-6 relative max-h-[85vh] overflow-y-auto">
                    <button onClick={onClose} className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors">
                        <X className="w-5 h-5" />
                    </button>
                    <h2 className="text-lg font-semibold text-gray-900 mb-2">Archive Content</h2>
                    <p className="text-sm text-gray-600 mb-4">
                        Are you sure you want to archive <span className="font-semibold">{row.title}</span>? This content will no longer be visible to learners.
                    </p>
                    <div className="flex gap-3 justify-end">
                        <button onClick={onClose} className="px-5 py-2 rounded-lg border border-gray-200 text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors">
                            Cancel
                        </button>
                        <button
                            onClick={handleConfirm}
                            disabled={loading}
                            className="px-5 py-2 rounded-lg bg-red-600 text-white text-sm font-medium hover:bg-red-700 disabled:opacity-50 transition-colors"
                        >
                            {loading ? "Archiving..." : "Archive"}
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    function ReclassifyAudienceModal({ row, onClose, onSubmit }) {
        useLockBodyScroll(true);
        const [selected, setSelected] = useState(row?.audience_code ? row?.audience_code : null);
        const [loading, setLoading] = useState(false);

        const audiences = [
            { value: "B2C", label: "B2C Only" },
            { value: "B2B", label: "B2B Only" },
            { value: "BOTH", label: "Both" },
        ];

        const getCurrentAudienceLabel = () => {
            if (!row.audience_code) return "Unset";
            if (row.audience_code === "B2C") return "B2C Only";
            if (row.audience_code === "B2B") return "B2B Only";
            if (row.audience_code === "BOTH") return "Both";
            return row.audience_code;
        };

        console.log(row, "rowrowrowrowrowrowrowrowrow");

        const planNames = row.subscription_names ? row.subscription_names.split(',').map(s => s.trim()) : [];

        const handleSubmit = async () => {
            if (!selected) return;
            setLoading(true);
            await onSubmit(selected);
            setLoading(false);
        };

        return (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40" style={{ paddingTop: '64px' }}>
                <div className="bg-white rounded-2xl shadow-xl w-full max-w-lg mx-4 p-6 relative max-h-[85vh] overflow-y-auto">
                    <button
                        onClick={onClose}
                        className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
                    >
                        <X className="w-5 h-5" />
                    </button>

                    <h2 className="text-lg font-semibold text-gray-900 mb-1">Reclassify Audience</h2>

                    <div className="mb-5">
                        <p className="text-base font-semibold text-gray-900">{row.title}</p>
                        <p className="text-sm text-gray-500">
                            Current audience:{" "}
                            <span className="font-medium text-gray-700">{getCurrentAudienceLabel()}</span>
                        </p>
                    </div>

                    <p className="text-sm font-medium text-gray-700 mb-3">New audience</p>

                    <div className="flex gap-3 mb-5">
                        {audiences.map((opt) => (
                            <button
                                key={opt.value}
                                onClick={() => setSelected(opt.value)}
                                className={`flex-1 px-4 py-2 rounded-lg border text-sm font-medium transition-all ${selected === opt.value
                                    ? "bg-blue-600 border-blue-600 text-white"
                                    : "border-gray-200 text-gray-700 hover:border-gray-300 hover:bg-gray-50"
                                    }`}
                            >
                                {opt.label}
                            </button>
                        ))}
                    </div>

                    <div className="border border-gray-200 rounded-lg px-4 py-3 mb-6 bg-gray-50">
                        {planNames && planNames?.length > 0 && (
                            <div>
                                <p className="text-xs text-gray-500 mb-2">STAYS IN</p>

                                <div className="space-y-2">
                                    {planNames.map((name, index) => (
                                        <div key={index} className="flex items-center gap-2">
                                            <span className="text-green-500">✓</span>

                                            <span className="text-sm text-gray-700">{name}</span>

                                            <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${row.audience_code === 'B2C'
                                                ? 'bg-blue-100 text-blue-600'
                                                : row.audience_code === 'B2B'
                                                    ? 'bg-blue-100 text-blue-600'
                                                    : 'bg-gray-100 text-gray-600'
                                                }`}
                                            >
                                                {row.audience_code}
                                            </span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="flex gap-3 justify-end">
                        <button onClick={onClose} className="px-5 py-2 rounded-lg border border-gray-200 text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors">
                            Cancel
                        </button>
                        <button onClick={handleSubmit} disabled={!selected || loading} className="px-5 py-2 rounded-lg bg-blue-600 text-white text-sm font-medium hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
                            {loading ? "Saving..." : "Save"}
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    function ActionMenu({ row, position, onClose, onMakeLive, onMakeInactive, onReclassify }) {
        const menuRef = useRef(null);
        const status = row.status_code?.toUpperCase();
        const isInactive = !status || status === "INACTIVE" || status === "ON_MAINTENANCE" || status === "DELETE";
        const isActive = status === "ACTIVE";
        useEffect(() => {
            const handleClickOutside = (e) => {
                if (
                    menuRef.current &&
                    !menuRef.current.contains(e.target)
                ) {
                    onClose();
                }
            };

            document.addEventListener("mousedown", handleClickOutside);

            return () => {
                document.removeEventListener(
                    "mousedown",
                    handleClickOutside
                );
            };
        }, [onClose]);


        return createPortal(
            <div
                ref={menuRef}
                style={{
                    position: "fixed",
                    top: `${position.top}px`,
                    right: `${position.right}px`,
                    zIndex: 99999,
                }}
                className="bg-white rounded-xl shadow-lg border border-gray-200 py-1 min-w-[170px]"
            >

                {isInactive && (
                    <button onClick={() => { onMakeLive(); onClose() }} className="w-full flex items-center gap-2.5 px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50">
                        <CheckCircle className="w-4 h-4 text-green-500" />
                        Make Live
                    </button>
                )}


                {isActive && (
                    <>
                        <button
                            onClick={() => {
                                onMakeInactive();
                                onClose();
                            }}
                            className="w-full flex items-center gap-2.5 px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50"
                        >
                            <XCircle className="w-4 h-4 text-gray-400" />
                            Make Inactive
                        </button>


                        <button
                            onClick={() => {
                                onReclassify();
                                onClose();
                            }}
                            className="w-full flex items-center gap-2.5 px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50"
                        >
                            <ArrowRight className="w-4 h-4 text-gray-400" />
                            Reclassify
                        </button>
                    </>
                )}

            </div>,
            document.body
        );
    }


    const getStatusLabel = (statusCode) => {
        const status = statusCode?.toUpperCase();
        if (status === "ACTIVE") return "Live";
        if (status === "INACTIVE" || status === "ON_MAINTENANCE") return "Inactive";
        if (status === "ARCHIVED") return "Archived";
        return "-";
    };

    const getDetails = async () => {
        try {
            setLoading(true);
            const res = await adminServices.getAssessmentCourseDetail(page, size, search, typeFilter, activeTab, audience, subtype);
            setData(res.data.details.data);
            setTotal(res.data.details.pagination.total);
            setCount(res.data.details.counts);
        } catch (err) {
            console.error("Failed to fetch content", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getDetails();
    }, [page, size, search, typeFilter, activeTab, audience, subtype]);

    const totalPages = Math.ceil(total / size);

    const handleClearFilters = () => {
        setSearch('');
        setTypeFilter('all');
        setPage(1);
        setAudience("All");
        setSubType("");
    };

    const handleMakeInactiveConfirm = async () => {
        try {
            await adminServices.UpdateGeneralAssessmentStatus(
                selectedRow.id,
                'INACTIVE',
                {
                    message: '',
                    fromDate: '',
                    toDate: '',
                    from: selectedRow.type?.toLowerCase() === 'assessment' ? 'assessment'
                        : selectedRow.type?.toLowerCase() === 'ebook' ? 'ebook'
                            : 'course'
                }
            );
            setMakeInactiveModal(false);
            setSelectedRow(null);
            getDetails();
        } catch (err) {
            console.error("Failed to make inactive", err);
        }
    };

    const handleMakeLiveSubmit = async (audienceValue) => {
        try {
            await adminServices.UpdateGeneralAssessmentStatus(
                selectedRow.id,
                'ACTIVE',
                {
                    message: '',
                    fromDate: '',
                    toDate: '',
                    audience: audienceValue,
                    from: selectedRow.type?.toLowerCase() === 'assessment' ? 'assessment'
                        : selectedRow.type?.toLowerCase() === 'ebook' ? 'ebook'
                            : 'course'
                }
            );
            console.log("Make Live:", selectedRow, audienceValue);
            setMakeLiveStep(null);
            setSelectedRow(null);
            getDetails();
        } catch (err) {
            console.error("Failed to make live", err);
        }
    };

    const handleArchiveConfirm = async () => {
        try {
            // await adminServices.archiveContent(selectedRow.id, selectedRow.type);
            console.log("Archive:", selectedRow.id);
            setArchiveModal(false);
            setSelectedRow(null);
            getDetails();
        } catch (err) {
            console.error("Failed to archive", err);
        }
    };

    const handleReclassifySubmit = async (audienceValue) => {

        try {
            await adminServices.UpdateGeneralAssessmentStatus(
                selectedRow.id,
                selectedRow.status_code,
                {
                    message: '',
                    fromDate: '',
                    toDate: '',
                    audience: audienceValue,
                    from: selectedRow.type?.toLowerCase() === 'assessment' ? 'assessment'
                        : selectedRow.type?.toLowerCase() === 'ebook' ? 'ebook'
                            : 'course'
                }
            );
            setReclassifyStep(null);
            setSelectedRow(null);
            getDetails();
        } catch (err) {
            console.error("Failed to reclassify", err);
        }
    };

    const combinedSubtypeOptions = [
        ...assessmentTypeList.map((item) => ({
            value: item.code,
            label: item.description || item.code,
        })),
        { value: "Simulation", label: "Simulation" },
        { value: "Video", label: "Video" },
        { value: "Combination", label: "Combination" },
    ];

    return (
        <Page title={"Content Bank"}>
            <div className="p-6 bg-gray-50 min-h-screen flex flex-col">

                <h1 className="text-xl font-semibold">Content Bank</h1>
                <p className="text-sm text-gray-500 mb-4">
                    Review, promote, and manage all platform content assets — assessments and courses.
                </p>

                <div className="flex gap-6 border-b mb-4">
                    <div className="flex gap-6 border-b mb-4">
                        {tabs.map((tab) => (
                            <button disabled={tab.disable}
                                key={tab.data}
                                onClick={() => { setActiveTab(tab.data); setPage(1); }}
                                className={`pb-2 text-sm font-medium border-b-2 ${activeTab === tab.data
                                    ? "border-blue-600 text-blue-600"
                                    : "border-transparent text-gray-500"
                                    }`}
                            >
                                {tab.label} {tab.count}
                            </button>
                        ))}
                    </div>
                </div>

                <div className="flex flex-wrap gap-3 mb-4">
                    <input
                        value={search}
                        onChange={(e) => { setSearch(e.target.value); setPage(1); }}
                        type="text"
                        placeholder="Search by title..."
                        className="border rounded-md px-3 py-2 text-sm w-64"
                    />
                    <select value={typeFilter} onChange={(e) => { setTypeFilter(e.target.value); setPage(1) }} className="border rounded-md px-3 py-2 text-sm">
                        <option value="all">All Types</option>
                        <option value="COURSE">Course</option>
                        <option value="ASSESSMENT">Assessment</option>
                        {/* <option value="EBOOK">Ebook</option> */}
                    </select>
                    <select value={audience} onChange={(e) => { setAudience(e.target.value); setPage(1) }} className="border rounded-md px-3 py-2 text-sm">
                        <option value="All">All Audiences</option>
                        <option value="B2B">B2B</option>
                        <option value="B2C">B2C</option>
                        <option value="BOTH">Both</option>
                        <option value="">Unset</option>
                    </select>
                    <select value={subtype} onChange={(e) => { setSubType(e.target.value); setPage(1) }} className="border rounded-md px-3 py-2 text-sm">
                        <option value="">All Categories</option>

                        {combinedSubtypeOptions.map((option) => (
                            <option key={option.value} value={option.value}> {option.label} </option>
                        ))}
                    </select>
                    <button onClick={handleClearFilters} className="text-sm text-blue-600 hover:text-blue-700 font-medium">
                        Clear All
                    </button>
                </div>

                <div className="flex flex-col flex-1">
                    <div className="bg-white rounded-xl shadow-sm overflow-hidden min-h-[400px] flex flex-col">
                        <div ref={tableContainerRef} className="flex-1 overflow-auto">
                            <table className="w-full text-sm">
                                <thead className="bg-gray-50 text-gray-500 text-xs uppercase sticky top-0">
                                    <tr>
                                        <th className="text-left px-4 py-3">Title</th>
                                        <th className="text-left px-4 py-3">Type</th>
                                        <th className="text-left px-4 py-3">Category</th>
                                        <th className="text-left px-4 py-3">Status</th>
                                        <th className="text-left px-4 py-3">Audience</th>
                                        <th className="text-left px-4 py-3">Plans</th>
                                        <th className="text-left px-4 py-3">Created</th>
                                        <th className="px-4 py-3" />
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading ? (
                                        <tr>
                                            <td colSpan="8" className="p-0">
                                                <div className="flex items-center justify-center h-[400px]">Loading...</div>
                                            </td>
                                        </tr>
                                    ) : data?.length === 0 ? (
                                        <tr>
                                            <td colSpan="8" className="p-0">
                                                <div className="flex items-center justify-center h-[400px]">No data found</div>
                                            </td>
                                        </tr>
                                    ) : (
                                        data.map((row) => {
                                            const formattedStatus = getStatusLabel(row.status_code);
                                            return (
                                                <tr key={`${row.type}-${row.id}`} className="border-t hover:bg-gray-50">
                                                     <td className="px-4 py-3 font-medium text-gray-800">
                                                        {row.title}
                                                        {row.internaltitle && (
                                                            <span className="ml-1 text-gray-500">({row.internaltitle})</span>
                                                        )}
                                                    </td>
                                                    
                                                    <td className="px-4 py-3">
                                                        <span className={`px-2 py-1 rounded-full text-xs font-medium ${typeStyles[row.type]}`}>
                                                            {row.type === "ASSESSMENT" ? "Assessment" : row.type === "EBOOK" ? "Ebook" : "Course"}
                                                        </span>
                                                    </td>

                                                    <td className="px-4 py-3 text-gray-600 font-medium tracking-wide">
                                                        {row.assessment_type_code ? (
                                                            <>
                                                                {row.assessment_type_code.toUpperCase()}
                                                                {row.sub_type && (
                                                                    <span className="text-gray-400 mx-2">·</span>
                                                                )}
                                                                {row.sub_type && (
                                                                    <span className="text-gray-400">
                                                                        {row.sub_type}
                                                                    </span>
                                                                )}
                                                            </>
                                                        ) : (
                                                            "-"
                                                        )}
                                                    </td>
                                                    <td className="px-4 py-3">
                                                        <span className={`px-2 py-1 rounded-full text-xs font-medium ${statusStyles[formattedStatus]}`}>
                                                            {formattedStatus}
                                                        </span>
                                                    </td>
                                                    <td className="px-4 py-3">
                                                        {row?.audience_code ? (
                                                            <span className="px-2 py-1 rounded-full text-xs font-medium bg-purple-100 text-purple-700">
                                                                {row.audience_code}
                                                            </span>
                                                        ) : '-'}
                                                    </td>
                                                    <td className="px-4 py-3 text-gray-700">
                                                        {row.subscription_count > 0
                                                            ? `${row.subscription_count} ${row.subscription_count > 1 ? "plans" : "plan"}`
                                                            : "—"}
                                                    </td>
                                                    <td className="px-4 py-3 text-gray-500">
                                                        {moment(row.created_at).format("D MMM YYYY")}
                                                    </td>
                                                    <td className="px-4 py-3 text-gray-500">
                                                        <div className="relative flex items-center justify-end">
                                                            <button
                                                                // disabled={row.subscription_count === 0 || row.subscription_count === "0"}
                                                                ref={(el) => (menuRefs.current[`btn_${row.id}`] = el)}
                                                                type="button"
                                                                onClick={() => {
                                                                    // if (row.subscription_count === 0 || row.subscription_count === "0") return;

                                                                    if (openActionMenuId === row.id) {
                                                                        setOpenActionMenuId(null);
                                                                        return;
                                                                    }

                                                                    const btn = menuRefs.current[`btn_${row.id}`];
                                                                    if (btn) {
                                                                        const rect = btn.getBoundingClientRect();

                                                                        const menuEstimatedHeight = 90;
                                                                        const spaceBelow = window.innerHeight - rect.bottom;
                                                                        let topPosition;

                                                                        if (spaceBelow < menuEstimatedHeight) {
                                                                            topPosition = rect.top - menuEstimatedHeight - 4;
                                                                        } else {
                                                                            topPosition = rect.bottom + 4;
                                                                        }


                                                                        setMenuPosition({
                                                                            top: topPosition,
                                                                            right: window.innerWidth - rect.right,
                                                                        });
                                                                    }

                                                                    setOpenActionMenuId(row.id);
                                                                }}
                                                                className={`p-2 rounded-lg transition-colors duration-150 text-gray-600 hover:text-gray-900 hover:bg-gray-100 cursor-pointer}`}
                                                                title={row.subscription_count === 0 || row.subscription_count === "0" ? 'No subscriptions available' : 'Actions'}>
                                                                <MoreVertical className="w-5 h-5" />
                                                            </button>

                                                            {openActionMenuId === row.id && (
                                                                <ActionMenu row={row}
                                                                    position={menuPosition}
                                                                    setMenuPosition={setMenuPosition}
                                                                    onClose={() => setOpenActionMenuId(null)}
                                                                    onMakeLive={() => {
                                                                        setSelectedRow(row);
                                                                        setMakeLiveStep('confirm');
                                                                    }}
                                                                    onMakeInactive={() => {
                                                                        setSelectedRow(row);
                                                                        setMakeInactiveModal(true);
                                                                    }}
                                                                    onReclassify={() => {
                                                                        setSelectedRow(row);
                                                                        setReclassifyStep('confirm');
                                                                    }}
                                                                    onArchive={() => {
                                                                        setSelectedRow(row);
                                                                        setArchiveModal(true);
                                                                    }}
                                                                />
                                                            )}
                                                        </div>

                                                        {/* <button
                                                            // disabled={row.subscription_count === 0 || row.subscription_count === "0"}
                                                            ref={(el) => (menuRefs.current[`btn_${row.id}`] = el)}
                                                            type="button"
                                                            onClick={() => {
                                                                if (row.subscription_count === 0 || row.subscription_count === "0") return;

                                                                if (openActionMenuId === row.id) {
                                                                    setOpenActionMenuId(null);
                                                                    return;
                                                                }

                                                                const btn = menuRefs.current[`btn_${row.id}`];
                                                                if (btn) {
                                                                    const rect = btn.getBoundingClientRect();
                                                                    setMenuPosition({
                                                                        top: rect.bottom + 4,
                                                                        right: window.innerWidth - rect.right,
                                                                    });
                                                                }

                                                                setOpenActionMenuId(row.id);
                                                            }}
                                                            className={`p-2 rounded-lg transition-colors duration-150 ${row.subscription_count === 0 || row.subscription_count === "0" ? 'text-gray-400 cursor-not-allowed bg-transparent' : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100 cursor-pointer'}`}
                                                            title={row.subscription_count === 0 || row.subscription_count === "0" ? 'No subscriptions available' : 'Actions'}>
                                                            <MoreVertical className="w-5 h-5" />
                                                        </button> */}

                                                    </td>
                                                </tr>
                                            );
                                        })
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="flex items-center justify-between mt-4 mt-auto">
                        <div className="text-sm text-gray-500">
                            Showing {(page - 1) * size + 1} – {Math.min(page * size, total)} of {total}
                        </div>
                        <div className="flex items-center gap-2">
                            <button onClick={() => setPage(1)} disabled={page === 1} className="px-2 py-1 border rounded disabled:opacity-50">{"<<"}</button>
                            <button onClick={() => setPage((prev) => prev - 1)} disabled={page === 1} className="px-3 py-1 border rounded disabled:opacity-50">Prev</button>
                            <span className="px-3 text-sm">{page} / {totalPages}</span>
                            <button onClick={() => setPage((prev) => prev + 1)} disabled={page === totalPages} className="px-3 py-1 border rounded disabled:opacity-50">Next</button>
                            <button onClick={() => setPage(totalPages)} disabled={page === totalPages} className="px-2 py-1 border rounded disabled:opacity-50">{">>"}</button>
                        </div>
                    </div>
                </div>
            </div>

            {makeLiveStep === 'confirm' && selectedRow && (
                <MakeLiveConfirmModal
                    row={selectedRow}
                    onClose={() => { setMakeLiveStep(null); setSelectedRow(null); }}
                    onContinue={() => setMakeLiveStep('audience')}
                />
            )}

            {makeLiveStep === 'audience' && selectedRow && (
                <MakeLiveAudienceModal
                    row={selectedRow}
                    onClose={() => { setMakeLiveStep(null); setSelectedRow(null); }}
                    onSubmit={handleMakeLiveSubmit}
                />
            )}

            {makeInactiveModal && selectedRow && (
                <MakeInactiveModal
                    row={selectedRow}
                    onClose={() => { setMakeInactiveModal(false); setSelectedRow(null); }}
                    onConfirm={handleMakeInactiveConfirm}
                />
            )}

            {archiveModal && selectedRow && (
                <ArchiveConfirmModal
                    row={selectedRow}
                    onClose={() => { setArchiveModal(false); setSelectedRow(null); }}
                    onConfirm={handleArchiveConfirm}
                />
            )}

            {reclassifyStep === 'confirm' && selectedRow && (
                <ReclassifyConfirmModal
                    row={selectedRow}
                    onClose={() => { setReclassifyStep(null); setSelectedRow(null); }}
                    onContinue={() => setReclassifyStep('audience')}
                />
            )}

            {reclassifyStep === 'audience' && selectedRow && (
                <ReclassifyAudienceModal
                    row={selectedRow}
                    onClose={() => { setReclassifyStep(null); setSelectedRow(null); }}
                    onSubmit={handleReclassifySubmit}
                />
            )}
        </Page>
    );
}